import React from 'react';

export default function ProgressBar({ value, max, label }) {
  const percent = max > 0 ? Math.min(100, (value / max) * 100) : 0;
  return (
    <div>
      {label && (
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
          <span className="label" style={{ margin: 0 }}>{label}</span>
          <span style={{ fontSize: 'var(--font-size-small)', color: 'var(--text-secondary)' }}>
            {value}/{max}
          </span>
        </div>
      )}
      <div className="progress-bar-container">
        <div className="progress-bar-fill" style={{ width: `${percent}%` }} />
      </div>
    </div>
  );
}